//
// Module for the DRO Setup wizard's Options step
//
rs.module("participant/benefit/setup/dro/wizard/optionsstep",

    [ "common/visibility" ],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, codeValues) {

            // Get the wizard buttons
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            var wizardBackButton = $(`[data-wizard]`).js("_back");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);

            var calculationMethodSelect = stepContainer.js(jsSelectors.calculationMethodSelect);
            var percentageInput = stepContainer.js(jsSelectors.percentageInput);
            var includeColaDiv = stepContainer.js(jsSelectors.includeColaDiv);
            var includeColaCheckBox = includeColaDiv.js(jsSelectors.includeColaCheckBox);

            // On initialize of page, we're going somewhere, just don't know where necessarily
            setWizardNextButtonText();

            // On initialize of page, we don't ever want to go back and attempt making duplicate claims
            wizardBackButton.setDisabled();

            // set display of Wizard's next button text to Next
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
            }

            // toggle based on Calculation Method
            calculationMethodSelect.change(function () {
                var disable = calculationMethodSelect.val() != codeValues.calculationMethodPercent;

                percentageInput.val("").prop("disabled", disable).clearErrors();
                includeColaCheckBox.setChecked(false).clearErrors();
                visibility.setVisible(includeColaDiv, !disable);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);